export default {
  beakpoints: ['xl', 'lg', 'md', 'sm', 'xs'],
  valueByBreakpoint(breakpointName, values, propFunction) {
  //Todo same like in fincraft pligins
  for (let i = this.beakpoints.indexOf(breakpointName); i < this.beakpoints.length; i++) {
    const targetSize = this.beakpoints[i]
    const prop = propFunction ? propFunction(targetSize) : targetSize
    const value = values[prop]

    if (value !== undefined) {
      return value
    }
  }
  return undefined
}
}
